import React from 'react'
import { useTranslation } from 'react-i18next';
import HeaderIconsGroup from '../shared/HeaderIconsGroup';

const PendingFirstDisbursement = ({ isLoan, isIgr, IconSatis, IconExcl, IconMult, mp }) => {
    const { t } = useTranslation();

    return (
        <div className="card-early">
            <p className='title-cards-early'><b>{t('extended_report.eligible_projects_pending_first_disbursement')}</b></p>
            <p className='sub-title-cards-early'>{t('extended_report.subtitle_projects_pending')}</p>

            <HeaderIconsGroup
                showValues={Boolean(isLoan | isIgr)}
                projectsLabel={t('one_pager_report.projects')}
                items={[
                    {
                        Icon: IconSatis,
                        text: t('extended_report.less_than_1_month'),
                        value: mp.ProjectElegibleFirstUndisbursement.satisfactory,
                    },
                    {
                        Icon: IconExcl,
                        text: t('extended_report.one_to_six_months_after_eligibility'),
                        value: mp.ProjectElegibleFirstUndisbursement.warning,
                    },
                    {
                        Icon: IconMult,
                        text: t('extended_report.more_than_six_months'),
                        value: mp.ProjectElegibleFirstUndisbursement.alert,
                    },
                ]}
            />
        </div>
    )
}

export default PendingFirstDisbursement